/*
 * @Author:
 * @LastEditTime: 2024-12-19 15:59:01
 * @Description:
 */
import DoublePreventionManagementRoutes from './routes'
import 'windi.css'

export default {
  // name version 必须为字面常量
  name: 'double-prevention-management-sm',
  title: '双重预防机制',
  version: '0.9.33',
  description: '智慧安全双重预防机制',
  routes: DoublePreventionManagementRoutes, // 导出相关路由
  sysRoutes: [], // ·系统管理· 下的路由，可以为空
  dependencies: {
    // 这里记录本模块所依赖接口
    apis: [],
  },
}
